import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'lib-file-upload-dialog',
  imports: [MatDialogModule, CommonModule],
  templateUrl: './file-upload-dialog.component.html',
  styleUrl: './file-upload-dialog.component.scss',
})
export class FileUploadDialogComponent {
  selectedFile: File | null = null;
  validationMessage: string | null = null;

  constructor(
    private readonly dialogRef: MatDialogRef<FileUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    // Reset state
    this.validationMessage = null;
    this.selectedFile = null;

    if (!file) return;

    const fileName = file.name.toLowerCase();

    // Filename prefix validation
    if (this.data?.projectCategory) {
      const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
      if (!fileNameWithoutExtension.toLowerCase().startsWith(this.data.projectCategory.toLowerCase())) {
        this.validationMessage = `File name must start with '${this.data.projectCategory}'.`;
        event.target.value = ''; // Reset file input
        return;
      }
    }

    const allowedExtensions = ['.csv', '.xlsx', '.xlsm'];
    const allowedMimeTypes = [
      'text/csv',
      'application/vnd.ms-excel', // old csv mime (Excel exports)
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12' // .xlsm mime type
    ];

    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    const hasValidMime = allowedMimeTypes.includes(file.type);

    if (!hasValidExtension && !hasValidMime) {
      this.validationMessage = 'Invalid file type. Only .csv, .xlsx, and .xlsm files are allowed.';

      // Reset file input so user can re-select same file
      event.target.value = '';
      return;
    }

    this.selectedFile = file;
  }


  confirmUpload() {
    if (this.selectedFile) {
      this.dialogRef.close(this.selectedFile);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
